import React, { useCallback, useEffect, useState } from "react";

import PsContext from "./index";

import { Backdrop, CircularProgress } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import jwt from "expo-jwt";
import { _LIST_SETTINGS } from "../models/settingsModel";
import {
  APP_STORAGE_KEY_VALUE,
  findCommonElement,
  getLs,
  setLs,
  upperCase,
} from "../utils";

const PsContextProvider = (props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const breakpoint = 620;

  const token = "21R91541sD5411H0G5";

  useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
       the "width" state variable when the window size changes */
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
  }, []);

  const isMobileView = () => (windowWidth < breakpoint ? true : false);

  const getPermissions = () => {
    return getLs("user_permissions") &&
      getLs("user_permissions") !== "undefined"
      ? JSON.parse(getLs("user_permissions"))
      : [];
  };

  const checkUserLogged = () => {
    let ud = getLs("user");
    if (ud && ud.length > 4) {
      return 1;
    } else return 0;
  };

  const [state, setState] = useState([]);
  const [loader, setLoader] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  const [userLogged, setUserLogged] = useState(checkUserLogged());
  const [settings, setSettings] = useState([]);
  const [userToken, setUserToken] = useState("");
  const [userData, setUserData] = useState([]);
  const [accessPermissions, setAccessPermissions] = useState(getPermissions());

  useEffect(() => {
    setLoader(true);
    _LIST_SETTINGS({ sta: "1" }).then((res) => {
      if (res.status == "1") {
        let set = res.data;
        let per = res.permissions || [];
        if (per && per.length > 0) {
          setLs("user_permissions", JSON.stringify(per));
          setAccessPermissions(per);
        }
        updateSettings(set);
      }
      setLoader(false);
    });
    loadSettingsValues();
  }, []);

  const updateSettings = (set) => {
    try {
      if (set && set !== undefined) {
        set = set.trim();
        if (!set.includes("{")) {
          setLs("settings", set);
          let decoded = jwt.decode(set, token);

          setSettings(decoded);
          return decoded;
        }
      }
    } catch (er) {}
  };

  const loadSettingsValues = () => {
    let d = getLs("settings");
    if (d && d.length > 3) updateSettings(d);
    let ud = getLs("user");
    if (ud && ud.length > 4) {
      let ua = getLs("token");
      if (ua) {
        setUserToken(ua);
      } else {
        setUserLogged("0");
      }

      setUserData(JSON.parse(ud));
      forceUpdate();
    } else {
      setUserLogged("0");
    }
  };

  const updateLogin = (api, userData, permissionData = []) => {
    setLs("user_permissions", JSON.stringify(permissionData));
    setAccessPermissions(permissionData);

    setUserToken(api);
    setUserData(userData);
    setLs("token", api);
    setLs("user", JSON.stringify(userData));
    setUserLogged("1");
  };

  const logout = () => {
    localStorage.clear();
    setLs("settings", settings);
    setUserToken("");
    setUserData([]);
    setUserLogged("0");
    setAccessPermissions([]);
  };

  const settingValue = (key) => {
    let m = settings && settings.find((item) => item.field_name == key);
    return m && m.field_name ? m.field_value : false;
  };

  const allowedAccess = (module, action) => {
    try {
      if (upperCase(userData.role) == "DEV") return true;

      if (!module || !action) return false;

      if (upperCase(module) == "ANY" && upperCase(action) == "ANY") return true;

      if (module && Array.isArray(module)) {
        let allowedModules = findCommonElement(
          accessPermissions.map((item) => item.module),
          module
        );
        return allowedModules;
      }

      let moduleExist = accessPermissions.filter(
        (item) => upperCase(item.module) == upperCase(module)
      );

      if (!moduleExist || moduleExist.length < 1) return false;

      let allowed = moduleExist.find(
        (item) => upperCase(item.action_name) == upperCase(action)
      );

      return allowed ? true : false;
    } catch (er) {
      return false;
    }
  };

  const forceUpdate = useCallback(() => setState({}), []);

  return (
    <PsContext.Provider
      value={{
        state: state,
        settings: settings,
        isMobileView: isMobileView,
        setLoader: setLoader,
        setAlertMsg: setAlertMsg,
        userLogged: userLogged,
        setUserLogged: setUserLogged,
        updateLogin: updateLogin,
        userData: userData,
        userToken: userToken,
        logout: logout,
        settingValue: settingValue,
        allowedAccess: allowedAccess,
        accessPermissions: accessPermissions,
      }}
    >
      {props.children}

      <Snackbar
        open={alertMsg && alertMsg.length > 0}
        onClose={(e) => setAlertMsg("")}
        message={alertMsg || "Message"}
        autoHideDuration={2500}
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
      />

      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 999 })}
        open={loader}
        onClick={(e) => {}}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </PsContext.Provider>
  );
};

export default PsContextProvider;
